import { memo } from 'react'
import useCruiseFAQ from './FaqHelper'
import CruiseFAQSection from './CruiseFAQSection'
interface Props {
  cruiseLine: App.CruiseLine
  ship: App.CruiseShip
  cruiseType: App.CruiseType
  compact?: boolean
}

function CruiseFAQ({ cruiseLine, ship, cruiseType, compact = false }: Props) {
  const faq = useCruiseFAQ(cruiseLine, ship, cruiseType)

  return (
    <>
      {faq.map((faqSection, index) => (
        <CruiseFAQSection key={index} FAQItem={faqSection} compact={compact} />
      ))}
    </>
  )
}

export default memo(CruiseFAQ)
